var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcoCheck = function SvgIcoCheck(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.9 16.9",
    enableBackground: "new 0 0 16.9 16.9",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0C3.8,0,0,3.8,0,8.4s3.8,8.5,8.5,8.5S17,13.1,17,8.4S13.1,0,8.5,0z M13.2,6.2l-5.4,5.4c-0.3,0.3-0.8,0.3-1.2,0L3.8,9 C3.4,8.7,3.4,8.2,3.7,7.8c0.3-0.3,0.8-0.4,1.2,0l0,0l2.3,2.1L12,5c0.3-0.3,0.9-0.3,1.2,0l0,0C13.5,5.3,13.5,5.9,13.2,6.2L13.2,6.2 L13.2,6.2z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_check.05fc106e.svg";
export { ForwardRef as ReactComponent };